import { Card, CardHeader, CardContent, Typography, Box, Button } from "@mui/material"
import { Users,CheckCircle, ArrowRight } from "lucide-react"
import { NavLink } from "react-router-dom"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
const textColor = "#0d2561"
const itextColor = "#707070"
export default function ConnectionsWidget() {
  const totalConnections = 285

  return (
    <Card>      
      <CardContent>
        <Typography variant="h6" sx={{ color: textColor, mb: 1 }}>
          Connections
        </Typography>
        <Typography variant="body2" sx={{ color: itextColor, mb: 2 }}>
          Total connections made to date.
        </Typography>
        <Box display="flex" alignItems="center" gap={2} mt={1}>
          <Users style={{width:"2rem",height:"2rem",color:"#0d2561"}}/>    
          <Typography variant="h4" color="#0d2561">
            {totalConnections}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" ml={7}>
          Total Connections
        </Typography>

        <Box textAlign="right" marginTop="175px">
          <NavLink to="#" style={{ textDecoration: "none" }}>
            <Button
              variant="text"
              size="small"
              endIcon={<ArrowForwardIcon />}
              sx={{
                textTransform: "none",
                fontSize: "0.875rem",
                p: 0,
                minHeight: "auto",
                color: textColor
              }}
            >
              View all connections
            </Button>
          </NavLink>
        </Box>
      </CardContent>
    </Card>
  )
}
